import type { FastifyInstance } from 'fastify'
import { clanRoutes } from './clan.routes.js'
import { ClanController } from './clan.controller.js'
import { db } from '../../core/database/firebase.js'

export default async function clanModule(app: FastifyInstance) {
  const controller = new ClanController(db)
  
  // Register routes with controller
  await clanRoutes(app, controller)
}
